exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.bottom-bar {\r\n  position: fixed;\r\n  bottom: 15px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  gap: 12px;\r\n  padding: 8px 14px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 12px rgba(0,0,0,0.2);\r\n  z-index: 2000;\r\n}\r\n\r\n.bottom-bar button {\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 6px 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.bottom-bar button:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-btn {\r\n  background: transparent;\r\n  padding: 0;\r\n  border: none;\r\n  outline: none;\r\n  box-shadow: none;\r\n  white-space: nowrap;\r\n  cursor: pointer;\r\n}\r\n\r\n.icon-btn[disabled] {\r\n  color: #888;\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n}\r\n\r\n.icon-btn[disabled] .icon-img,\r\n.icon-btn[disabled] .disabled-icon {\r\n  filter: grayscale(100%);\r\n  opacity: 0.6;\r\n}\r\n\r\n.icon-img {\r\n  width: 16px;\r\n  height: 16px;\r\n}\r\n\r\n\r\n.separator {\r\n  width: 1px;\r\n  height: 20px;\r\n  background: #ddd;\r\n  margin: 6px 6px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/bottom-bar/bottom-bar.component.css
// module id = 743
// module chunks = 1